module.exports = __webpack_public_path__ + "static/media/menu-icon.552dd9ea.svg";